import { Lightning as lng } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';
import { Button } from '../../components/shared/Button';
import { ScreenSize } from '../../api/ScreenSize';

export class MessageDialog extends lng.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      w: w => w,
      h: h => h,
      rect: true,
      color: Theme.Colors.MessageDialog.Background,

      Dialog: {
        x: w => w / 2,
        y: h => h / 2,
        mountX: 0.5,
        mountY: 1,
        flex: { direction: 'column' },
        Title: {
          w: ScreenSize.w / 3,
          visible: this.bindProp('title', ctx => !!ctx.title),
          text: {
            text: this.bindProp('title'),
            ...Theme.Fonts.MessageDialog.Title,
          },
        },
        Message: {
          w: ScreenSize.w / 3,
          text: {
            text: this.bindProp('message'),
            ...Theme.Fonts.MessageDialog.Message,
          },
        },
        Button: {
          y: 16,
          type: Button,
          buttonMode: 'dialog',
          h: 80,
          label: this.bindProp('confirmText'),
          signals: {
            onActivate: '_activate',
          },
        },
      },
    };
  }

  _activate() {
    if (this.callToAction) {
      this.callToAction();
    }
    this.fireAncestors('$forceCloseMessage');
  }

  _getFocused() {
    return this.tag('Button');
  }

  _handleBack() {
    //do not allow closing the dialog via back
    return true;
  }
}
